import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-not-authorised-page',
  templateUrl: './not-authorised-page.component.html',
  styleUrls: ['./not-authorised-page.component.scss'],
  standalone: true,
  imports: [
    TranslateModule
  ]
})

export class NotAuthorisedPageComponent {

}